import React from 'react';
import AppSettingsContext from './context.js';
import * as u from './utils.js'
import TestimonialForm from './form.js';

/*---------------------------------------------*/

export default class SubmitButton extends React.Component {
	static contextType = AppSettingsContext;

	constructor(props) {
		super(props);

		this.openForm = this.openForm.bind(this);
	}

	openForm() {
		let params = TestimonialForm.getParams(this.context);
		let HEIGHTS = {
			text: 57,
			email: 57,
			url: 57,
			textarea: 124,
			image: 108,
			rating: 46,
		}

		let inputsHeight = params.map((param) => HEIGHTS[param.type]).reduce((sum, x) => sum + x);
		let titleHeight = 54;
		let buttonHeight = 50;
		let inputsSpacing = 24;
		let popupPadding = 24;
		let safetyMargin = 10;
		let formHeight = inputsHeight + buttonHeight + params.length*inputsSpacing;
		let popupHeight = titleHeight + inputsSpacing + formHeight + popupPadding*2 + safetyMargin;
		
		window.inffuse.utils.openPopup({
			url: document.location.href + "&endpoint=form",
			width: 600,
			height: popupHeight,
			onClose: function() {}
		});

		window.ga && window.ga('send','event','form','open');
	}

	render() {
		if (!this.context.get('form.enabled')) 
			return null;

		let textColor = u.renderColor(this.context.get('style.form.button.text','#333'));
		let bgColor = u.renderColor(this.context.get('style.form.button.bg'));
		let borderRadius = this.context.get('style.form.button.border.radius',2);

		let styles = {
			container: {
				...this.props.baseStyle,
				paddingTop: this.props.position === 'top' ? 16 : 16,
				paddingBottom: this.props.position === 'top' ? 16 : 40
			},
			button: {
				border: 'none',
				color: textColor,
				background: bgColor,
				borderRadius: borderRadius,
				lineHeight: 1.5,
    			padding: '0.5em calc(1em + 2px)',
				cursor: 'pointer',

				fontSize: 16,
				fontWeight: 'bold',
				fontStyle: 'normal',
				...u.getFontStyle(this.context,'style.form.button.font')
			}
		};
		
		let buttonLabel = this.context.get('form.button.text') || this.context.default('form.button.text');
		return (
			<div style={styles.container}>
				<button style={styles.button} onClick={this.openForm}>{buttonLabel}</button>
			</div>
		)
	}
}

/*---------------------------------------------*/
